import {useLocationBreadcrumbQuery} from "./queries.generated";
import BackendError from "../BackendError";
import Loading from "./Loading";
import RedirectToError from "../RedirectToError";
import {useParams} from "react-router";

export default function Location() {
    const {locationId} = useParams();

    const {loading, error, data} = useLocationBreadcrumbQuery({
        variables: {id: parseInt(locationId)},
    });

    if (loading) return <Loading />;

    if (error) return <BackendError error={error} />;

    if (data.locations.items.length !== 1) return <RedirectToError id="unknown_location" />;

    return <span>{data.locations.items[0].name}</span>;
}
